import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ListApplinksPage from '@jira/applinks__administration/src/ListPage.tsx';
import { applinksAdministrationListRoute } from '@jira/router-routes__admin-pages-applinks-routes/src/applinksAdministrationListRoute.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';

export const applinksAdministrationListRouteEntry: Route = createEntry(
	applinksAdministrationListRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'applinks-administration',

		// eslint-disable-next-line no-restricted-syntax
		component: ListApplinksPage,

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		canTransitionIn: () => true,
		forPaint: [LazyAtlassianNavigation],

		meta: {
			reporting: {
				id: 'Applinks',
				packageName: 'jiraAdminPagesApplinks',
				teamName: 'olympus',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
